export default function () {
  if (document.getElementById('proposal-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "proposal-offers-app" */ '@organisms/offer/proposal/main'
    );
  }
}
